import React from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import swal from 'sweetalert';

import { getCookie } from '../../../inc/cookies';
import config from '../../../inc/config';

import AddedCategoryFieldLanguageModal from '../../../component/category/categoryField/AddedCategoryFieldLanguageModal';

class CategoryFieldEditModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isOpenAddedCategoryFieldLanguageModal: false,

      sort: 0,
      dataType: '',
      inputType: '',
      widgetType: '',

      fieldLanguageId: 0,
      fieldLanguages: [],
      editCategoryFieldLanguages: null,

      // buttonRef: null,
      dataTypes: config.dataTypes,
      inputTypes: config.inputTypes,
      customWidgetList : config.customWidgetList
    };
    // this.buttonRef = React.createRef();
  }

  componentDidMount() {
    this.getCategoryFieldDetail();
    window.scrollTo(0, 0);
  }

  getCategoryFieldDetail() {
    let sessionHash = getCookie('sessionHash');

    this.setState({isLoading: true});

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    let errorMessages = [];
    let remaining = 2;
    let complete = () => {
      remaining--;
      if (remaining === 0) {
        if (errorMessages.length > 0) {
          swal({dangerMode: true, icon: 'warning', title: 'Hay Aksi', text: errorMessages[0], buttons: 'Tamam'}).then(this.props.navigate('/categoryFields'));
        }else{
          this.setState({isLoading: false});
        }
      }
    }

    fetch(config.restApi + 'field/tr/' + this.props.searchParams.get('id'), requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({sort: responseData.fieldInfo.sort, dataType: responseData.fieldInfo.dataType, inputType: responseData.fieldInfo.inputType, widgetType: responseData.fieldInfo.widgetType});
        }
        break;
        case 401:  {
          errorMessages.push(responseData.message)
        }
        break;
        default: {
          errorMessages.push(responseData.message);
        }
        break;
      }
      complete();
    }, () => errorMessages.push('Lütfen internet bağlantınızı kontrol ediniz.'));

    fetch(config.restApi + 'fieldLanguages/tr/' + this.props.searchParams.get('id'), requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({fieldLanguages: responseData.fieldLanguages});
        }
        break;
        case 401:  {
          errorMessages.push(responseData.message)
        }
        break;
        default: {
          errorMessages.push(responseData.message);
        }
        break;
      }
      complete();
    }, () => errorMessages.push('Lütfen internet bağlantınızı kontrol ediniz.'));
  }

  dataTypeOnChange = (event) => {
    const selectedOptionName = event.target.value;
    const selectedOption = this.state.dataTypes.find((dataInfo) => dataInfo.name === selectedOptionName);
    this.setState({dataType: selectedOption.name});
  };

  inputTypeOnChange = (event) => {
    const selectedOptionName = event.target.value;
    const selectedOption = this.state.inputTypes.find((inputInfo) => inputInfo.name === selectedOptionName);
    this.setState({inputType: selectedOption.name});
  };

  fieldTypeOnChange = (event) => {
    const selectedOptionName = event.target.value;
    const selectedOption = this.state.customWidgetList.find((widgetInfo) => widgetInfo.name === selectedOptionName);
    this.setState({widgetType: selectedOption.name});
  };

  saveCategoryFieldOnClick = () => {
    let sessionHash = getCookie('sessionHash');

    let infoMessage = '';

    if (infoMessage) {
      swal({
        dangerMode: true,
        icon: 'info',
        title: 'Eksik Bilgi',
        text: infoMessage,
        buttons: 'Tamam'
      });
    } else {
      this.setState({isLoading: true});

      const requestOptions = {
        method: 'PUT',
        headers: {'Authorization': 'Bearer ' + sessionHash, 'Content-Type': 'application/json'},
        body: JSON.stringify({dataType: this.state.dataType, inputType: this.state.inputType, widgetType: this.state.widgetType, sort: parseInt(this.state.sort)})
      };

      fetch(config.restApi + 'field/tr/' + this.props.searchParams.get('id'), requestOptions)
      .then(response => response.json())
      .then(responseData => {
        this.setState({isLoading: false});

        switch (responseData.status) {
          case 200: {
            swal({
              dangerMode: true,
              icon: 'success',
              title: 'Tamamlandı',
              text: 'Özel alan başarıyla güncellendi.',
              buttons: 'Tamam'
            });
          }
          break;
          case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          })
        break;
          default: {
            swal({
              dangerMode: true,
              icon: 'warning',
              title: 'Hay Aksi',
              text: responseData.message,
              buttons: 'Tamam'
            });
          }
          break;
        }
      }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
    }
  }

  saveCategoryFieldLanguageOnClick(categoryFieldLanguageInfo, id) {

    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'POST',
      headers: {'Authorization': 'Bearer ' + sessionHash, 'Content-Type': 'application/json'},
      body: JSON.stringify({name: categoryFieldLanguageInfo.name, language: categoryFieldLanguageInfo.language, description: categoryFieldLanguageInfo.description})
    };

    fetch(config.restApi + 'fieldLanguage/tr/' + id, requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch (responseData.status) {
        case 200: {
          swal({
            dangerMode: true,
            icon: 'success',
            title: 'Tamamlandı',
            text: 'Özel alana ait çeviri başarıyla eklendi.',
            buttons: 'Tamam'
          }).then(() => this.getCategoryFieldDetail(), this.setState({isOpenAddedCategoryFieldLanguageModal: false}), categoryFieldLanguageInfo.name = '', categoryFieldLanguageInfo.language = '', categoryFieldLanguageInfo.description = '');
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          })
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  updateCategoryFieldLanguageOnClick(categoryFieldLanguageInfo, id) {
    
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'PUT',
      headers: {'Authorization': 'Bearer ' + sessionHash, 'Content-Type': 'application/json'},
      body: JSON.stringify(categoryFieldLanguageInfo)
    };

    fetch(config.restApi + 'fieldLanguage/tr/' + id, requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch (responseData.status) {
        case 200: {
          swal({
            dangerMode: true,
            icon: 'success',
            title: 'Tamamlandı',
            text: 'Çeviri başarıyla güncellendi.',
            buttons: 'Tamam'
          }).then(() => this.getCategoryFieldDetail(), this.setState({isOpenAddedCategoryFieldLanguageModal: false, editCategoryFieldLanguages: categoryFieldLanguageInfo}));
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          })
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  deleteCategoryFieldLanguageOnClick(id) {
    swal({
      dangerMode: true,
      icon: 'warning',
      title: 'Onayla',
      text: 'Çeviriyi silmek istediğinize emin misiniz?',
      buttons: {confirm: 'Tamam', cancel: 'Vazgeç'}
    }).then(value => {
      if (value) {
        let sessionHash = getCookie('sessionHash');

        const requestOptions = {
          method: 'DELETE',
          headers: {'Authorization': 'Bearer ' + sessionHash}
        };

        fetch(config.restApi + 'fieldLanguage/tr/' + id, requestOptions)
        .then(response => response.json())
        .then(responseData => {
          switch (responseData.status) {
            case 200: {
              swal({
                dangerMode: true,
                icon: 'success',
                title: 'Tamamlandı',
                text: 'Çeviri başarıyla silindi.',
                buttons: 'Tamam'
              }).then(() => this.getCategoryFieldDetail());
            }
            break;
            default: {
              swal({
                dangerMode: true,
                icon: 'warning',
                title: 'Hay Aksi',
                text: responseData.message,
                buttons: 'Tamam'
              });
            }
            break;
          }
        }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
      }
    });
  }
  
  handleKeyPress = (event) => {
    if(event.key === 'Enter') {
      this.saveCategoryFieldOnClick();
    }
  }

  // handleClick = (fieldLanguageInfo) => {
  //   this.setState({
  //     editCategoryFieldLanguages: fieldLanguageInfo,
  //     isOpenAddedCategoryFieldLanguageModal: true,
  //     fieldLanguageId: fieldLanguageInfo.id,
  //     buttonRef: this.buttonRef.current,
  //   }, () => {
  //     this.state.buttonRef.focus();
  //   });
  // }

  render() {
    return this.state.isLoading ?
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
      :
      <>
      <div className="row">
        <div className="col">
          <div className="ibox">
            <div className="ibox-title text-darkblue d-flex justify-content-between pr-2">
              <h5>Özel Alan Düzenle</h5>
              <div>
                <button className="btn btn-orange mr-2" title="Kaydet" onClick={this.saveCategoryFieldOnClick}><i className="fa fa-save"></i></button>
                <button className="btn btn-darkblue text-white" title="Geri" onClick={() => {this.props.navigate(-1)}}><i className="fa fa-reply"></i></button>
              </div>
            </div>
            <div className="ibox-content">
              <div className="row mb-5">
                <div className="col-md-6">
                  <strong className="text-darkblue">Alan Tipi<strong className="text-danger ml-1">*</strong></strong>
                  <select className="form-control form-control-sm form-input mb-2 mt-1" onChange={this.fieldTypeOnChange} onKeyDown={this.handleKeyPress} value={this.state.widgetType}>
                    <option value="" disabled>Seçiniz</option>
                    {this.state.customWidgetList.map((customWidgetListInfo) => <option key={customWidgetListInfo.id} value={customWidgetListInfo.name}>{customWidgetListInfo.name}</option>)}
                  </select>
                </div>
                <div className="col-md-6">
                  <strong className="text-darkblue">Giriş Tipi<strong className="text-danger ml-1">*</strong></strong>
                  <select className="form-control form-control-sm form-input mb-2 mt-1" onChange={this.inputTypeOnChange} onKeyDown={this.handleKeyPress} value={this.state.inputType}>
                    <option value="" disabled>Seçiniz</option>
                    {this.state.inputTypes.map((inputTypeInfo) => <option key={inputTypeInfo.id} value={inputTypeInfo.name}>{inputTypeInfo.name}</option>)}
                  </select>
                </div>
              </div>
              <div className="row mb-5">
                <div className="col-md-6">
                  <strong className="text-darkblue">Veri Tipi<strong className="text-danger ml-1">*</strong></strong>
                  <select className="form-control form-control-sm form-input mb-2 mt-1" onChange={this.dataTypeOnChange} onKeyDown={this.handleKeyPress} value={this.state.dataType}>
                    <option value="" disabled>Seçiniz</option>
                    {this.state.dataTypes.map((dataTypeInfo) => <option key={dataTypeInfo.id} value={dataTypeInfo.name}>{dataTypeInfo.name}</option>)}
                  </select>
                </div>
                <div className="col-md-6">
                  <strong className="text-darkblue">Sıralama<strong className="text-danger ml-1">*</strong></strong>
                  <input className="form-control form-input mb-2 mt-1" min="0" onChange={(event) => this.setState({sort: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Sıralama" type="number" value={this.state.sort} />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="d-flex justify-content-between">
                    <h4 className="text-darkblue">Özel Alana Ait Çeviri Listesi</h4>
                    <button className="btn btn-orange" onClick={() => this.setState({editCategoryFieldLanguages: null, isOpenAddedCategoryFieldLanguageModal: true})} title="Dil Ekle"><i className="fa fa-plus"></i></button>
                  </div>
                  <div className="hr-line-dashed"></div>
                  <div className="row">
                    <div className="col">
                    <div className="overflow-auto">
                      <table className="table table-striped table-bordered">
                      <thead>
                        <tr className="text-center text-darkblue">
                          <th>Çeviri</th>
                          <th>Dil</th>
                          <th>Açıklama</th>
                          <th>Durum</th>
                          <th>İşlem</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {this.state.fieldLanguages.map((fieldLanguageInfo) =>
                          <tr key={fieldLanguageInfo.id}>
                            <td className="align-middle text-orange">{fieldLanguageInfo.name}</td>
                            <td className="align-middle">{fieldLanguageInfo.language}</td>
                            <td className="align-middle">{fieldLanguageInfo.description}</td>
                            <td className="align-middle">{fieldLanguageInfo.active === 1 ? 'Açık' : 'Kapalı'}</td>
                            <td className="align-middle" style={{minWidth:98.5}}>
                              <button className="btn btn-outline btn-orange text-center m-1" onClick={() => this.setState({isOpenAddedCategoryFieldLanguageModal: true, fieldLanguageId: fieldLanguageInfo.id, editCategoryFieldLanguages: fieldLanguageInfo})} title="Düzenle"><i className="fa fa-pencil text-white action-icon"></i></button>
                              <button className="btn btn-outline btn-darkblue" onClick={() => this.deleteCategoryFieldLanguageOnClick(fieldLanguageInfo.id)} title="Sil"><i className="fa fa-trash"></i></button>
                            </td>
                          </tr>
                        )}
                        {this.state.fieldLanguages.length === 0 ?
                          <tr>
                            <td className="align-middle p-3" colSpan="5">Çeviri Listesi Bulunamadı !</td>
                          </tr>
                        : null}
                      </tbody> 
                      </table>
                    </div>
                    </div>
                  </div>
                  <AddedCategoryFieldLanguageModal isOpen={this.state.isOpenAddedCategoryFieldLanguageModal} modalTitle="Çeviri Ekle" modalDescription="Özel alana ait çeviri eklemek için aşağıdaki alanları doldurunuz !" onRequestClose={() => this.setState({editCategoryFieldLanguages: null, isOpenAddedCategoryFieldLanguageModal: false})} saveOnClick={categoryFieldLanguageInfo => this.saveCategoryFieldLanguageOnClick(categoryFieldLanguageInfo, this.props.searchParams.get('id'))} />
                  {this.state.editCategoryFieldLanguages ?
                  <AddedCategoryFieldLanguageModal buttonRef={this.state.buttonRef} defaultValue={this.state.editCategoryFieldLanguages} isOpen={this.state.isOpenAddedCategoryFieldLanguageModal} modalTitle="Çeviri Düzenle" modalDescription="Çeviri bilgisini düzenlemek için aşağıdaki bilgileri doldurunuz !" onRequestClose={() => this.setState({editCategoryFieldLanguages: null, isOpenAddedCategoryFieldLanguageModal: false})} saveOnClick={categoryFieldLanguageInfo => this.updateCategoryFieldLanguageOnClick(categoryFieldLanguageInfo, this.state.fieldLanguageId)} />
                  : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>
  }
}

export default function CategoryFieldEdit() {
  return (
    <CategoryFieldEditModule navigate={useNavigate()} searchParams={useSearchParams()[0]} />
  )
}